import {z} from 'zod';

import i18n from '@dms/i18n';

export const createTireLocationSchema = z.object({
  location: z.string().min(1, {message: i18n.t('general.validations.fieldIsRequired')}),
  allowMultipleUsage: z.boolean(),
  note: z.string().trim(),
});
